import { VideoSessionOutputDTO } from '@maiia/model/generated/model/api-patient/api-patient';

// Helper function for check video status with typescript support
// eslint-disable-next-line import/prefer-default-export
export const checkVideoStatusIs = (
  videoStatus: VideoSessionOutputDTO['videoSessionStatus'] | undefined,
  statuses: VideoSessionOutputDTO['videoSessionStatus'][],
) => videoStatus && statuses.includes(videoStatus);
